'use strict';

const msg = require('../messages.js');
const utils = require('../utils.js');

function ValidationMixin () {
  var cls = {
    fieldError: 'field--error',
    invisible: 'invisible'
  };

  var refs = {
    notification: '[data-ref*="notification"]'
  };

  this.getNotification = function (element) {
    var notification = '';
    var ref = element.getAttribute('data-ref');
    var validity = element.validity;
    if (ref.match(/input-email/) && validity.typeMismatch) {
      notification = msg.invalidEmail;
    } else if (validity.valueMissing || validity.customError) {
      notification = msg.required;
    }
    return notification;
  };

  this.setValidField = function (fieldSelector) {
    var field = document.querySelector(fieldSelector);
    if (field.className.includes(' ' + cls.fieldError)) {
      field.className = field.className.replace(' ' + cls.fieldError, '');
    }

    var notification = field.querySelector(refs.notification);
    if (!notification.className.includes(cls.invisible)) {
      notification.className = notification.className
        .concat(' ' + cls.invisible);
    }

    var notificationText = notification.firstElementChild;
    utils.clearDOM(notificationText);
  };

  this.setInvalidField = function (fieldSelector, elementSelector) {
    var field = document.querySelector(fieldSelector);
    if (!field.className.includes(' ' + cls.fieldError)) {
      field.className = field.className.concat(' ' + cls.fieldError);
    }

    var notification = field.querySelector(refs.notification);
    notification.className = notification.className
      .replace(' ' + cls.invisible, '');

    var notificationText = notification.firstElementChild;
    utils.clearDOM(notificationText);

    var element = field.querySelector(elementSelector);
    notificationText.appendChild(
      document.createTextNode(this.getNotification(element))
    );
  };

  return this;
}

module.exports = ValidationMixin;



//////////////////
// WEBPACK FOOTER
// ./_js/mixins/validation.js
// module id = 19
// module chunks = 0 1 2